// import { toast } from "react-toastify";
import { toast } from "react-toastify";
import { api, constants, dateHelpers } from '.';

// eslint-disable-next-line import/no-anonymous-default-export
export default {

  downloadSpecReportPdf(itemNumber) {
    const payload = {
      ItemNumber: itemNumber
    };
    api.postDownloadBinary(
      'Report/SpecificationReport',
      payload,
      constants.MIME_TYPES.pdf,
      `Specification_Report_${itemNumber}_${dateHelpers.getDateStringForReportName()}.pdf`,
      "There was an error downloading the specification report"
    )
    .then((res) => {
      if(res?.data === false) {
        toast.error(res.message);
      }
    })
    .catch((error) => {
      api.catchHandler(error);
    })
  },

  getCaseLotInventoryReport(itemNumber, orderSite = null) {
    const payload = {
      ItemNumber: itemNumber,
      OrderSite: orderSite
    }

    api
      .postDownloadBinary(
        'Report/CaseLotInventory',
        payload,
        constants.MIME_TYPES.pdf,
        `Case_Lot_Inventory_${itemNumber}${orderSite !== null ? `_${orderSite}` : ``}_${dateHelpers.getDateStringForReportName()}.pdf`,
        "There was an error downloading the Case Lot Inventory report"
      )
      .then((res) => {
        if(res?.data === false) {
          toast.error(res.message);
        }
      })
      .catch((error) => {
        api.catchHandler(error)
      });
  },

  getCustomerSpecReport(customerId, itemNumber) {
    const payload = {
      CustomerId: customerId,
      ItemNumber: itemNumber
    }
    // api.post('Reference/SpecificationExist', payload).then((r) => { I might enable this later but for now I will leave it
    // if(r && r.data && r.data.exist) {
    api
      .postDownloadBinary(
        'Report/CustomerSpecificationReport',
        payload,
        constants.MIME_TYPES.pdf,
        `Specification_Report_${itemNumber}_${dateHelpers.getDateStringForReportName()}.pdf`
      )
      .then((res) => {
        if (res?.data === false) {
          toast.error(res.message);
        }
      }).catch(api.catchHandler)
    // } 
    // else {
    //   toast.info(`No Specification found for Item ${itemNumber}`)
    // }
    // })
  },
};